import React from 'react';
import { Instagram, Facebook, Twitter, Youtube, MapPin, Clock, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-black text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="space-y-4">
            <h3 className="text-2xl font-bold mb-4">عروسة عدن</h3>
            <p className="text-gray-300">
              عطور تقليدية يمنية فاخرة مصنوعة بحب واهتمام، لنقدم لكم تجربة عطرية فريدة من نوعها.
            </p>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-xl font-bold mb-4">معلومات المتجر</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-2 space-x-reverse">
                <MapPin className="h-5 w-5 text-brand-pink mt-1 shrink-0" />
                <div>
                  <p className="font-bold mb-1">العنوان:</p>
                  <p>الديره مول، صنعاء، اليمن</p>
                </div>
              </li>
              <li className="flex items-start space-x-2 space-x-reverse">
                <Clock className="h-5 w-5 text-brand-pink mt-1 shrink-0" />
                <div>
                  <p className="font-bold mb-1">ساعات العمل:</p>
                  <p>السبت - الخميس: ١٠ صباحًا - ١ ظهرًا</p>
                  <p>٤ مساءً - ٨:٣٠ مساءً</p>
                  <p>الجمعة: ٤ مساءً - ٨:٣٠ مساءً</p>
                </div>
              </li>
            </ul>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-xl font-bold mb-4">تواصل معنا</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-2 space-x-reverse">
                <Phone className="h-5 w-5 text-brand-pink mt-1 shrink-0" />
                <div>
                  <p className="font-bold mb-1">الهاتف:</p>
                  <a href="tel:00967781115437" className="hover:text-brand-pink transition-colors">00967781115437</a>
                </div>
              </li>
              <li className="flex items-start space-x-2 space-x-reverse">
                <Mail className="h-5 w-5 text-brand-pink mt-1 shrink-0" />
                <div>
                  <p className="font-bold mb-1">البريد الإلكتروني:</p>
                  <a href="mailto:info@arousat-aden.com" className="hover:text-brand-pink transition-colors">info@arousat-aden.com</a>
                </div>
              </li>
              <li className="flex space-x-4 space-x-reverse pt-2">
                <a 
                  href="https://www.instagram.com/arousat.aden" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-white/10 hover:bg-brand-pink transition-colors p-2 rounded-full"
                  aria-label="Instagram"
                >
                  <Instagram className="h-5 w-5" />
                </a>
                <a 
                  href="#" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-white/10 hover:bg-brand-pink transition-colors p-2 rounded-full"
                  aria-label="YouTube"
                >
                  <Youtube className="h-5 w-5" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/20 mt-12 pt-6 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} عروسة عدن. جميع الحقوق محفوظة.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
